export const isValidLast4CardNumber = (last4: string): boolean => {
  // this line filters out NaN as well as "0000"
  return Number(last4) && last4.length === 4 ? true : false;
};
